import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import { blue } from "@mui/material/colors";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import image1 from "../../../../assets/advisory/adebayo.jpg";

const Details = () => {
  return (
    <Box margin={{ xs: "30% 0%", sm: "10% 0%" }}>
      <Typography variant={"subtitle2"} fontWeight={700}>
        Law Consultant
      </Typography>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        flexWrap={"wrap"}
        width={{ xs: "100%", sm: "40%" }}
        marginLeft={{ xs: "0%", sm: "0%" }}
      >
        <Box
          width={{ xs: "100%", sm: "100%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
        >
          <Typography
            variant={"h3"}
            fontWeight={900}
            textAlign={"left"}
            color={"#00AEEF"}
            paddingBottom={"1%"}
          >
            Tope Adebayo
          </Typography>
        </Box>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          width={{ xs: "50%", sm: "35%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
        >
          <Box
            component="a"
            underline="none"
            target={"_blank"}
            href="https://www.facebook.com/topeadebayo.lawyer/"
            title="Facebook"
          >
            <Avatar
              sx={{
                bgcolor: blue[900],
                width: 46,
                height: 46,
              }}
            >
              <FacebookIcon />
            </Avatar>
          </Box>
          <Box
            component="a"
            underline="none"
            target={"_blank"}
            href="https://www.twitter.com/"
            title="Twitter"
          >
            <Avatar
              sx={{
                bgcolor: "#000",
                width: 46,
                height: 46,
              }}
            >
              <XIcon />
            </Avatar>
          </Box>
          <Box
            component="a"
            underline="none"
            target={"_blank"}
            href="https://linkedin.com/in/tope-adebayo-37205814a"
            title="LinkedIn"
          >
            <Avatar
              sx={{
                bgcolor: blue[700],
                width: 46,
                height: 46,
              }}
            >
              <LinkedInIcon />
            </Avatar>
          </Box>
        </Box>
      </Box>
      <Grid container marginTop={{ xs: "10%", sm: "2%" }}>
        <Grid
          item
          xs={12}
          sm={4}
          paddingRight={{ xs: "0%", sm: "3%" }}
          paddingTop={{ xs: "5%", sm: "0%" }}
        >
          <Box
            component="img"
            height={{ xs: "50vh", sm: "400px" }}
            paddingBottom={{ xs: "7%", sm: "0%" }}
            sx={{
              objectFit: "cover",
              position: "relative",
              overflow: "hidden",
              borderRadius: "5px",
              width: "100%",
            }}
            src={image1}
            alt={"about-image"}
          />
        </Grid>
        <Grid item xs={12} sm={4} paddingRight={{ xs: "0%", sm: "2%" }}>
          <Typography
            variant="body1"
            color={"#4f4f4f"}
            paragraph
            lineHeight={1.5}
          >
            Tope is an alumnus of the Prestigious Harvard Kennedy School of
            Executive Education (Leaders in Development: Managing Change in a
            Dynamic World), He is an Attorney with vast experience in Dispute
            Resolution, Specialized Transaction and Corporate/Commercial
            practice. He started his legal career with the leading commercial
            law firm of Olaniwun Ajayi LP where he developed proficiency in
            litigation, receivership, arbitration as well as project and
            corporate finance. He later joined the respected law office of Afe
            Babalola SAN & Co where he deepened his experience in litigation and
            arbitration practices.
          </Typography>
          <Typography
            variant="body1"
            color={"#4f4f4f"}
            paragraph
            lineHeight={1.5}
            paddingTop={{ xs: "0.5%", sm: "1%" }}
          >
            Tope has participated in some of the most challenging cases in
            banking, finance, corporate law and commercial law and has also
            commendably handled many cases in the superior courts of records in
            Nigeria including the Court of Appeal and Supreme Court. At both Afe
            Babalola SAN & Co and Olaniwun Ajayi LP, Tope acted for and against
            multinational corporations including Shell BP, Chevron, Mobil and
            Pan Ocean Nigeria Ltd.
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={4}
          paddingRight={{ xs: "0%", sm: "2%" }}
          paddingTop={{ xs: "0.5%", sm: "0%" }}
        >
          <Typography variant="body1" color={"#4f4f4f"} paragraph>
            He has also participated in disputes arising from company management
            and administration especially in telecommunications, oil and gas
            industries. At Afe Babalola, he was one of the lawyers who
            represented the respondent in the case of UBA v. BTL, a case which
            recorded the payments of the highest amount in damages against a
            bank for negligent handling of Client’s transactions in our recent
            history. Tope graduated as the best student at Faculty of Law,
            University of Ado-Ekiti (where he was also President of the
            Students’ Union). In addition, Tope coveted another prize in his LLM
            programme at University of Lagos where he graduated as the best
            student. He, in fact, won the Hoponu Wusu prize for the best
            graduating student in LLM in year 2008 at the University of Lagos.
          </Typography>
          <Typography
            variant="body1"
            color={"#4f4f4f"}
            paragraph
            paddingTop={{ xs: "0.5%", sm: "1%" }}
          >
            Tope is a full member of the International Bar Association. He is
            registered with the Securities and Exchange Commission as a capital
            market consultant and also registered with the Financial Reporting
            Council of Nigeria (FRCN). He is the Senior Partner of the firm and
            Partner in charge of Dispute Resolution and Specialized Transaction.
            Tope is a fellow of the Nigerian Institutue of Chartered
            Arbitrators.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Details;
